import packageJson from "../../../package.json";

export const APP_VERSION =
  process.env.REACT_APP_VERSION || packageJson.version || "2.1.0";

export const UPDATE_TYPE_OPTIONS = [
  { value: "patch", label: "Patch" },
  { value: "bug-fix", label: "Bug fix" },
  { value: "small-update", label: "Small update" },
  { value: "major-update", label: "Major update" },
];

export const UPDATE_TYPE_LABELS = UPDATE_TYPE_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {},
);

export function parseSemver(version) {
  const match = String(version || "")
    .trim()
    .match(/^v?(\d+)\.(\d+)\.(\d+)$/i);

  if (!match) return null;

  return {
    major: Number(match[1]),
    minor: Number(match[2]),
    patch: Number(match[3]),
  };
}

export function formatSemver(parts) {
  if (!parts) return APP_VERSION;
  return `${Number(parts.major || 0)}.${Number(parts.minor || 0)}.${Number(
    parts.patch || 0,
  )}`;
}

export function normalizeSemver(version, fallback = APP_VERSION) {
  return formatSemver(parseSemver(version) || parseSemver(fallback));
}

export function bumpAppVersion(version, updateType) {
  const parsed = parseSemver(version) || parseSemver(APP_VERSION);
  if (!parsed) return APP_VERSION;

  switch (updateType) {
    case "major-update":
      return formatSemver({
        major: parsed.major + 1,
        minor: 0,
        patch: 0,
      });
    case "small-update":
      return formatSemver({
        major: parsed.major,
        minor: parsed.minor + 1,
        patch: 0,
      });
    case "patch":
    case "bug-fix":
    default:
      return formatSemver({
        major: parsed.major,
        minor: parsed.minor,
        patch: parsed.patch + 1,
      });
  }
}

export function compareSemver(left, right) {
  const a = parseSemver(left);
  const b = parseSemver(right);
  if (!a || !b) return 0;

  if (a.major !== b.major) return a.major > b.major ? 1 : -1;
  if (a.minor !== b.minor) return a.minor > b.minor ? 1 : -1;
  if (a.patch !== b.patch) return a.patch > b.patch ? 1 : -1;
  return 0;
}

export function isVersionNewer(candidate, current) {
  return compareSemver(candidate, current) > 0;
}
